import './src/vaadin-input-container.js';
export * from './src/vaadin-input-container.js';
